module.exports = __webpack_public_path__ + "img/图1  步辇图.27eea42a.jpg";